import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { isFloatingAssistantHiddenRoute } from '../Layout/floatingAssistantRoutes';
import { APP_PAGES } from '../routes/constants';
import { useAgentConversationsStore } from '../store/AgentConversations';
import { useFloatingAssistantStore } from '../store/FloatingAssistant';

export function useOpenAgentConversationInDock(): (
  conversationId: string,
) => void {
  const setFocusedId = useAgentConversationsStore((s) => s.setFocusedId);
  const open = useFloatingAssistantStore((s) => s.open);
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (conversationId: string) => {
      setFocusedId(conversationId);
      if (isFloatingAssistantHiddenRoute(location.pathname)) {
        navigate(`${APP_PAGES.ASSISTANT}/${conversationId}`);
        return;
      }
      open();
    },
    [setFocusedId, open, navigate, location.pathname],
  );
}
